

import React from 'react';
import { TextField } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';






export const InputDePassword = ({ value, setValue, placeholder, name="password", required = true }) => {


    const [showPassword, setShowPassword] = React.useState(false);


    const handleClickShowPassword = () => { 
        setShowPassword((show) => !show);
    };


    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };



    return (

        <>
            <TextField 
                required={required}
                label={ placeholder }
                type={showPassword ? 'text' : 'password'}
                placeholder={ placeholder }
                fullWidth
                name={name}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                InputProps={{
                endAdornment:(
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                        { showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                )
                }}
            />
        </>

    )

    
}
